import { w3cwebsocket } from 'websocket';

export const WebSocket = () => {
  const client = new w3cwebsocket(import.meta.env.VITE_WEBSOCKET_URL);
  return client;
};
